import Store from "../store/index";
import { getIsSentryBoxTabs } from "./service";

export function setWsMsgData(obj, SentryBoxId, key) {
  let needMore = Store.state.layout.isSentryBoxTabs ? Store.state.layout.isSentryBoxTabs === 'true' : getIsSentryBoxTabs() === 'true';
  let arr = Store.state.order[key];
  if (!arr[SentryBoxId]) {
    arr[SentryBoxId] = []
  }
  if (!needMore) {
    let chekcArr = Object.keys(arr).filter(v => {return v !== 'lastKey' && v !== SentryBoxId});
    if (chekcArr.length > 0) delete arr[chekcArr[0]];
  }
  // console.log(arr)
  return arr
}

export function getSameValue(SentryBoxId, storeArr, obj, key) {
  let sameArr = storeArr[SentryBoxId].filter(v => {
    return v[key] === obj[key]
  });
  return sameArr;
}

export function checkLeftGateTab(orderArr = undefined) {
  // console.log(Store.state.order.leftGateIdTabs)
  let tabsArr = JSON.parse(Store.state.order.leftGateIdTabs);
  if (!orderArr) {
    orderArr = Store.state.order.moreWsData[Store.state.order.moreWsData.lastKey]
  }
  tabsArr.forEach(v => {
    let arr02 = orderArr.filter(vv => {return parseInt(vv.park_lot_gate_id) === v.Id});
    if (arr02.length === 0) {
      v.orderId = undefined;
      v.hidden = true;
    } else {
      v.orderId = parseInt(arr02[0].order_id);
      v.hidden = arr02[0].isPaid
    }
  });
  Store.dispatch("SetLeftGateIdTabs", JSON.stringify(tabsArr));
}

export function checkParkInGateTab() {
  let inGateIds = JSON.parse(Store.state.order.inGateIdTabs);
  let moreBlackParkIn = Store.state.order.moreBlackParkIn;
  inGateIds.forEach(v => {
    v.hidden = true;
    let arr = moreBlackParkIn[moreBlackParkIn.lastKey].filter(vv => {return parseInt(vv.park_lot_gate_id) === v.Id});
    // console.log(arr)
    if (arr.length > 0 && arr[0].message_type !== '5' && arr[0].message_type !== '32') {
      v.hidden = false;
    }
  });
  Store.dispatch("SetInGateIdTabs", JSON.stringify(inGateIds));
  // console.log(Store.state.order.inGateIdTabs)
}
